import script from "./AiHistoryView.vue?vue&type=script&setup=true&lang=js"
export * from "./AiHistoryView.vue?vue&type=script&setup=true&lang=js"

import "./AiHistoryView.vue?vue&type=style&index=0&id=098b3be7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-098b3be7"]])

export default __exports__